module.exports = __webpack_public_path__ + "static/media/logo_WeChat.d42c42c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/solution/images/logo_WeChat.png
// module id = 378
// module chunks = 4